import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-zbewegungsart-list-view',
  imports: [],
  templateUrl: './zbewegungsart.list-view.html',
  styleUrls: ['./zbewegungsart.list-view.css'],
})
export class ZbewegungsartListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
